export default __webpack_public_path__ + "static/media/ContractStaff.b43ff8dd.jpeg";